import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getClient } from '@chegg/rio-sdk-web';
import cookies from 'js-cookie';
import { signinBaseEvent } from './presets';
export var keyToken = 'id_token';
var rioClient;
/**
 * Gets Uuid from `idToken` automatically (using `document.cookie` on Client-side)
 *
 * @param tokenCookie - Alternatively, you can pass this if you have an `idToken` available with the function caller
 * @returns Uuid or undefined
 *  */

export function getUuid(tokenCookie) {
  try {
    var token = tokenCookie || cookies.get(keyToken) || '';
    return JSON.parse(atob(token.split('.')[1])).sub;
  } catch (error) {
    // not caring about what kind of error is catched, as this function is supposed to return a Uuid string or undefined
    return undefined;
  }
} // if client does not exist, it will return a new, uninitialized client

export var initializeRioClient = function initializeRioClient(config, namespace) {
  rioClient = getRioClient(namespace);

  if (!rioClient.isInit && config) {
    rioClient.init(config);
  }
};
export var getRioClient = function getRioClient(namespace) {
  rioClient = getClient(namespace);
  return rioClient;
};
/** Updates Rio client with logged-in/-out state on Client-side */

export var updateAuthState = function updateAuthState() {
  var token = cookies.get(keyToken);

  if (token) {
    rioClient.updateState({
      authState: 'hard_logged_in',
      cheggUuid: getUuid(token)
    });
  } else {
    rioClient.updateState({
      authState: 'logged_out'
    });
  }
};
/** Sign in Rio Log for mobile and desktop */

export var signInRioLog = function signInRioLog() {
  return rioClient.sendEvent(_objectSpread(_objectSpread({}, signinBaseEvent), {}, {
    data: {},
    options: {}
  }));
};